import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { S as SmartClone } from '../SmartClone/SmartClone.js';

var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ModalTarget(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(SmartClone, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
}
ModalTarget.displayName = "Modal.Target";

export { ModalTarget as M };
//# sourceMappingURL=ModalTarget.js.map
